// src/firebase.js

import { initializeApp } from 'firebase/app';
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// 1) Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyC2NmyuY0xjuwoAILUgq5FaJYAH4_Q6I8o",
  authDomain: "stockanalysis-e7963.firebaseapp.com",
  projectId: "stockanalysis-e7963",
  storageBucket: "stockanalysis-e7963.firebasestorage.app",
  messagingSenderId: "76334570581",
  appId: "1:76334570581:web:6f69886fc17b5f9154c8dc",
  measurementId: "G-JZK3NVJEGP"
};

// 2) Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db   = getFirestore(app);

// 3) Debug helper
function debugFirebaseConfig() {
  console.log("Firebase config being used:", {
    apiKey:         firebaseConfig.apiKey ? "Set (hidden)" : "NOT SET",
    authDomain:     firebaseConfig.authDomain,
    projectId:      firebaseConfig.projectId,
    storageBucket:  firebaseConfig.storageBucket,
    messagingSenderId: firebaseConfig.messagingSenderId,
    appId:          firebaseConfig.appId ? "Set (hidden)" : "NOT SET",
    measurementId:  firebaseConfig.measurementId
  });
}

try {
  debugFirebaseConfig();
  console.log("Firebase initialized successfully!");
} catch (err) {
  console.error("Firebase initialization error:", err);
  throw err;
}

// 4) Set up Google provider
const googleProvider = new GoogleAuthProvider();

// Configure Google provider with custom parameters to help with security policies
googleProvider.setCustomParameters({
  // The 'prompt' parameter ensures the user sees the Google consent screen
  prompt: 'select_account',
  // Adding login_hint can help with user experience
  login_hint: '',
});

// 5) Auth‐related functions
export async function registerUser(email, password) {
  const cred = await createUserWithEmailAndPassword(auth, email, password);
  return cred.user;
}

export async function loginUser(email, password) {
  const cred = await signInWithEmailAndPassword(auth, email, password);
  return cred.user;
}

export async function signInWithGoogle() {
  try {
    // Use popup method with browser instead of redirect
    // The signInWithPopup method will check if the environment is acceptable to Google
    console.log("Attempting Google sign-in with popup...");
    const result = await signInWithPopup(auth, googleProvider);
    console.log("Google sign-in successful:", result.user.email);
    return result.user;
  } catch (error) {
    console.error("Google sign-in error:", error);
    
    // Check for specific Google OAuth errors related to environment
    if (error.code === 'auth/internal-error' && 
        (error.message.includes('disallowed_useragent') || 
         error.message.includes('web_internal_error'))) {
      console.error("Google blocked sign-in due to browser security policy.");
      // Re-throw with a more user-friendly message
      throw new Error("Browser not supported for Google sign-in. Please try a standard browser like Chrome, Firefox, or Edge.");
    }
    
    throw error;
  }
}

// Keep the handleRedirectResult function for backward compatibility
export async function handleRedirectResult() {
  try {
    const result = await getRedirectResult(auth);
    if (result) {
      // User is signed in
      console.log("Redirect sign-in successful:", result.user.email);
      return result.user;
    }
    // No redirect result (this is the first page load)
    return null;
  } catch (error) {
    console.error("Error handling redirect sign-in:", error);
    throw error;
  }
}

export async function logoutUser() {
  await signOut(auth);
}

export function getCurrentUser() {
  return auth.currentUser;
}

export function onAuthChange(callback) {
  // returns the unsubscribe function
  return onAuthStateChanged(auth, callback);
}